// Page home

var pageHome = {
  save_swiper_el: undefined,

  init: function () {
    this.homeSwiper();
  },

  homeSwiper: function () {
    var s = this;
    var swiper_el = $('.home-swiper');
    if (swiper_el.length == 0) return;

    swiper_el.each(function (id) {
      var th = $(this);
      var swiper_container = th.find('.swiper');
      var dots_el = th.find('.dots');
      var total = th.find('.swiper-slide').length;
      
      var _autoplay = th.data('autoplay') || false;
      var _speed = th.data('speed') || 1200;
      var _grab = th.is('.swiper-grab');
      var _loop = th.is('.swiper-loop');
      var video_el = th.find('video');
      var has_video = video_el.length > 0;

      if(has_video) video_el[0].pause();
      th.attr('id', 'home-swiper-' + id);

      if (total > 1 && dots_el.length) {
        for (var dot_i = 0; dot_i < total; dot_i++) {
          var dot = '<div class="dot"><svg viewBox="0 0 50 50" class="center"><circle class="line" cx="25" cy="25" r="22.5"/></svg></div>';
          dots_el.append(dot);
        }
      } else {
        _autoplay = false;
        _loop = false;
      }

      var save_id = 0;
      var loop_fixing = false;

      var swiper_obj = new Swiper(swiper_container[0], {
        pagination: {
          el: th.find('.swiper-pagination')[0],
          clickable: true
        },
        navigation: {
          nextEl: th.find('.btn-next')[0],
          prevEl: th.find('.btn-prev')[0]
        },
        autoplay: _autoplay > 0 ? {
          delay: _autoplay,
          disableOnInteraction: true
        } : false,

        effect: 'fade',
        // effect: 'creative',
        // creativeEffect: {
        //   prev: {
        //     opacity: 1
        //   },
        //   next: {
        //     opacity: 1
        //   }
        // },

        uniqueNavElements: false, //当存在多个同名导航元素时，设置导航元素是否唯一
        watchOverflow: true, //仅有 1 个 slide 时，swiper 无效
        direction: 'horizontal',
        loop: _loop,
        speed: _speed,
        grabCursor: _grab,
        longSwipesRatio: 0.2,
        threshold: 20,
        parallax: false,
        observer: true,
        // lazyLoading : true,
        // lazyLoadingInPrevNext : true,

        on: {
          init: function () {
            if (!_loop) {
              var active_anim_els = th.find('.swiper-slide-active .anim_el');
              animElements.anim_els(active_anim_els);
            }

            dots_el.find('.dot').eq(0).addClass('active');
          },

          progress: function(swiper){
            for (var i = 0; i < swiper.slides.length; i++) {
              var slide = swiper.slides[i];
              var slide_progress = slide.progress;
              var slide_el = $(slide);
              var pos_x = slide_progress * 50 + 50;
              if (pos_x > 100) pos_x = 100;
              if (pos_x < 0) pos_x = 0;

              slide_el.css('mask-position', pos_x + '% 100%');
            }
          },  

          autoplayStart: function () {
            th.addClass('autoplaying');
          },

          autoplayStop: function () {
            th.removeClass('autoplaying');
          },

          // touchMove: function () {
          //   console.log('touchMove');
          // },
          
          // beforeLoopFix: function () {
          //   // console.log('before');
          //   loop_fixing = true;
          // },
          
          // loopFix: function () {
          //   // console.log('fix');
          //   loop_fixing = false;
          //   save_id = this.activeIndex;
          //   th.find('.swiper-slide-active .anim_el').addClass('visb in');
          // },
          
          // transitionStart: function () {
          //   console.log('transitionStart');
          //   th.find('.swiper-slide .anim_el').removeClass('visb in');
          //   th.find('.swiper-slide-active .anim_el').addClass('visb in');
          // },

          transitionEnd: function () {
            if (loop_fixing) return;
            // console.log('transitionEnd');
            var active_id = this.activeIndex;
            // console.log('active_id = ' + active_id);
            // console.log('save_id = ' + save_id);
            s.videoPlay(th);
            if (active_id == save_id) return;
            // console.log('transitionEnd and Changed');
            th.find('.swiper-slide .anim_el').removeClass('visb in');
            var active_anim_els = th.find('.swiper-slide-active .anim_el');
            animElements.anim_els(active_anim_els);
            // video_set(swiper_obj);
            save_id = this.activeIndex;

            if (this.autoplay.running) {
              if (th.is('.pause')) {
                s.swiperPause(th);
              } else {
                var video_el = th.find('.swiper-slide-active video');
                if ( !video_el.is('.playing') ) th.addClass('autoplaying');
              }
            }

            // th.find('.swiper-slide:not(.swiper-slide-active) .anim_el').removeClass('visb in');
            // console.log('save_id = ' + save_id);
          },
          
          slideChangeTransitionStart: function () {
            // console.log('slideChangeTransitionStart');
            th.removeClass('autoplaying');
          },

          slideChange: function () {
            var active_id = this.realIndex;
            // console.log('slideChange: ' + active_id);
            dots_el.find('.dot.active').removeClass('active');
            dots_el.find('.dot').eq(active_id).addClass('active');

            s.videoPause(th);
          }
        }

      });
  
      dots_el.find('.dot').each(function (i) {
        var th = $(this);
        var endi = swiper_obj.params.loop ? i + 1 : i;
  
        th.on('click', function () {
          swiper_obj.slideTo(endi, _speed, swiper_obj.update);
        })
      });

      if (th.is('.top-slider')) {
        th.find('.slide-info a').each(function () {
          var a = $(this);
  
          a.on('mouseenter', function () {
            a.addClass('hover');
            if (!swiper_obj.autoplay.running) return;
            swiper_obj.autoplay.pause();
            swiper_obj.disable();
            th.removeClass('autoplaying');
            // s.swiperPause(th, true);
          });

          a.on('mouseleave', function () {
            a.removeClass('hover');
            if (!swiper_obj.autoplay.running || modal.modal_el.css('display') == 'block') return;
    
            if (th.find('video.playing').length) {
              // th.removeClass('pause');
              swiper_obj.enable();
            } else {
              // s.swiperReplay(th, true);
              swiper_obj.enable();
              swiper_obj.autoplay.run();
              th.addClass('autoplaying');
            }
          });
        });
      }

      th.find('.slide-info a').click(function () {
        s.swiperPause(th);
      });
      
      // th.addClass('swiper_init');
      th.attr('data-home-swiperid', id);
      window['home_swiper_' + id] = swiper_obj;

      s.videoPlay(th);
      s.scrollEvent();
    })

  },

  videoPause: function (swiper_el) {
    var video_el = swiper_el.find('video');
    if (video_el.length == 0) return;

    video_el.each(function () {
      $(this).off('ended').removeClass('playing');
      $(this)[0].pause();
    });
  },

  videoPlay: function (swiper_el) {
    var s = this;
    var swiper_obj = window['home_swiper_' + swiper_el.data('home-swiperid')];
    var slide_el = swiper_el.find('.swiper-slide-active');
    var video_el = slide_el.find('video');
    var slide_id = swiper_obj.realIndex;

    if ( video_el.length == 0 || swiper_el.is('.pause') || video_el.is('.playing') ) return;

    video_el.off('ended').addClass('playing');
    video_el[0].play();
    
    if (swiper_obj.autoplay.running) {
      swiper_el.removeClass('autoplaying');
      // swiper_obj.autoplay.pause();
      // console.log(swiper_obj.autoplay.paused);
      setTimeout(function () {
        swiper_obj.autoplay.pause();
      }, 300);
    }
    
    video_el.on('ended', function () {
      // console.log('video end');

      video_el.off('ended').removeClass('playing');
      if (swiper_el.is('.pause') || slide_id != swiper_obj.realIndex) return;

      if (swiper_obj.autoplay.running) {
        // swiper_el.addClass('autoplaying');
        swiper_obj.params.autoplay.delay = 0;
        swiper_obj.autoplay.run();
        swiper_obj.params.autoplay.delay = swiper_el.data('autoplay');
        // console.log('video end - autoplay run');
      } else {
        s.videoPlay(swiper_el);
      }
    });
  },

  swiperPause: function (el, no_pause_video) {
    var s = this;
    var swiper_el = el ? el : $('.top-slider');
    var swiper_obj = window['home_swiper_' + swiper_el.data('home-swiperid')];
    // if (el) s.save_swiper_el = el;
    
    if (no_pause_video == undefined) s.videoPause(swiper_el);
    swiper_el.addClass('pause');
    
    if (swiper_obj.autoplay.running) {
      swiper_obj.autoplay.pause();
      swiper_obj.disable();
      swiper_el.removeClass('autoplaying');
      // console.log(swiper_obj.autoplay);
    }
  },
  
  swiperReplay: function (el, no_play_video) {
    var s = this;
    var swiper_el = el ? el : $('.top-slider');
    var swiper_obj = window['home_swiper_' + swiper_el.data('home-swiperid')];
    var acitve_el = swiper_el.find('.swiper-slide-active');
    var a_el = acitve_el.find('.slide-info a');
    var video_el = acitve_el.find('video');
    var has_video = video_el.length > 0 ? true : false;

    if ( has_video && !video_el.is('.playing') && a_el.is('.hover') ) video_el[0].play();

    if ( swiper_el.is('.top-slider') && !swiper_el.is('.inview') || a_el.is('.hover') ) return;
    // if (el) s.save_swiper_el = undefined;

    swiper_el.removeClass('pause');
    if (has_video && no_play_video == undefined) s.videoPlay(swiper_el);

    if (swiper_obj.autoplay.running) {
      swiper_obj.enable();
      if (has_video && no_play_video == undefined) return;

      swiper_obj.autoplay.run();
      swiper_el.addClass('autoplaying');
    }
  },

  scrollEvent: function () {
    var s = this;

    var event = function () {
      var top_slider = $('.top-slider');
      var top = tt_root_scroll_wrap.scrollTop();
      var endv = top_slider.innerHeight() / 3;
      
      if (top < endv) top_slider.addClass('inview');
      else top_slider.removeClass('inview');

      if (top_slider.is('.inview')) s.swiperReplay(top_slider);
      else s.swiperPause(top_slider);

      var scroll_tip = $('.scroll-tip');
      if ( !top_slider.is('.inview') ) {
        scroll_tip.addClass('hide');
      }
    }

    tt_root_scroll_wrap.on('scroll', event);
    $(window).on('resize', event);
    event();
  }

}